"use strict";

import getSlug from "speakingurl";
import _ from "lodash";

/**
 * This Utility is used to format unique names and slugs for design items.
 * It assumes the use of Immutable data structures
 */
class NameSlugFormatter {
  static format(name, /**Immutable.List **/ items, /** Immutable.Map optional **/ currentItem) {
    var nameAndSlug = {};

    nameAndSlug.name = name;
    nameAndSlug.slug = getSlug(name);

    var count = 0;
    var origName = name;

    if (!NameSlugFormatter._isUniqueItemProps(nameAndSlug, items, currentItem)) {
      var newName = nameAndSlug.name;

      if (newName.indexOf("-") > 0) {
        var nameCount = newName.substr(newName.lastIndexOf("-") + 1);
        if (parseInt(nameCount) > 0) {
          origName = newName.substr(0, newName.lastIndexOf("-"));
          count = parseInt(nameCount) + 1;
          nameAndSlug = NameSlugFormatter._updateNameAndSlug(nameAndSlug, origName, count);
        }
      }

      while (!NameSlugFormatter._isUniqueItemProps(nameAndSlug, items, currentItem)) {
        count++;
        nameAndSlug = NameSlugFormatter._updateNameAndSlug(nameAndSlug, origName, count);
      }
    }

    return nameAndSlug;
  }

  static _updateNameAndSlug(nameAndSlug, origName, suffix) {
    nameAndSlug.name = origName + "-" + suffix;
    nameAndSlug.slug = getSlug(nameAndSlug.name);

    return nameAndSlug;
  }

  static _isUniqueItemProps(props, items, currentItem) {
    var isUnique = true;

    items.forEach(function (item) {
      var propsUnique = _.every(props, function (value, key) {
        return item.get(key) != value;
      });

      //handle case where it is checking itself
      if (!propsUnique && currentItem != null && item == currentItem) {
        propsUnique = true;
      }

      if (!propsUnique) {
        isUnique = false;
      }

      return propsUnique;
    });

    return isUnique;
  }
}

export default NameSlugFormatter;
